import React, {useRef} from 'react';
import { hot } from 'react-hot-loader';
import Dashboard from './Dashboard';
import PropTypes from "prop-types";

const App = (props) => {
  const scrollRef = useRef(null);

  return (
      <Dashboard studentId={ props.studentId }
                 studentAnnouncementEnabled={ props.studentAnnouncementEnabled }
                 hideServices={ props.hideServices }
                 scrollRef={ scrollRef }
                 showCalendarWidget={ props.showCalendarWidget }
                 showNotificationWidget={ props.showNotificationWidget }
                 showConnectionWidget={ props.showConnectionWidget }
                 showServiceWidget={ props.showServiceWidget }
                 studentHelpContentEmpty={ props.studentHelpContentEmpty }
                 studentHelpEnabled={ props.studentHelpEnabled }
                 studentHelpText={ props.studentHelpText }
                 successNetworkText={ props.successNetworkText }
                 studentSelfFlaggingEnabled={ props.studentSelfFlaggingEnabled }
                 requestHelpEnabled={ props.requestHelpEnabled }
                 responsiveKioskEnabled={ props.responsiveKioskEnabled }
                 virtualCheckInEnabled={ props.virtualCheckInEnabled }
      />
  )
};

App.propTypes = {
  studentId: PropTypes.number.isRequired,
  studentAnnouncementEnabled: PropTypes.bool.isRequired,
  hideServices: PropTypes.bool,
  showCalendarWidget: PropTypes.bool.isRequired,
  showNotificationWidget: PropTypes.bool.isRequired,
  showConnectionWidget: PropTypes.bool.isRequired,
  showServiceWidget: PropTypes.bool.isRequired,
  studentHelpContentEmpty: PropTypes.bool,
  studentHelpEnabled: PropTypes.bool,
  studentHelpText: PropTypes.string.isRequired,
  studentSelfFlaggingEnabled: PropTypes.bool,
  requestHelpEnabled: PropTypes.bool,
  successNetworkText: PropTypes.string.isRequired,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
};

export default hot(module)(App);
